<template>
  <div>
    <Head :title="$t('actions.create_model', [$t('models.election')])"/>

    <div class="flex justify-start mb-8">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.elections.index')">
          {{ $t('models.election') }}
        </Link>
        <span class="text-indigo-400 font-medium mx-2">/</span>
        {{ $t('ui.create') }}
      </h1>
      <div class="ml-auto">
        <Link class="inline-block btn-indigo" :href="route('admin.elections.index')">
          <span>{{ $t('ui.back') }}</span>
        </Link>
      </div>
    </div>

    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name"
                      class="pb-8 pr-6 w-full" :label="$t('fields.election.name')" autofocus/>

          <text-input v-model="form.datetime_start" :error="form.errors.datetime_start"
                      type="datetime-local"
                      :placeholder="datetimeInputPlaceholder" class="pb-8 pr-6 w-full lg:w-1/2"
                      :label="$t('fields.election.datetime_start')"/>

          <text-input v-model="form.datetime_end" :error="form.errors.datetime_end"
                      type="datetime-local"
                      :placeholder="datetimeInputPlaceholder" class="pb-8 pr-6 w-full lg:w-1/2"
                      :label="$t('fields.election.datetime_end')"/>

          <textarea-input v-model="form.description" :error="form.errors.description" rows="4"
                          class="pb-8 pr-6 w-full" :label="$t('fields.election.description')"/>

          <file-input v-model="form.cover_image" :error="form.errors.cover_image"
                      class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*"
                      :label="$t('fields.election.cover_image')"/>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ $t('actions.create_model', [$t('models.election')]) }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Layouts/Authenticated'
import FileInput from '@/Inputs/FileInput'
import TextInput from '@/Inputs/TextInput'
import SelectInput from '@/Inputs/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from "@/Inputs/TextareaInput";

export default {
  components: {
    TextareaInput,
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {},
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        datetime_start: '',
        datetime_end: '',
        description: '',
        cover_image: null,
      }),
      datetimeInputPlaceholder: `e.g. ${new Date().toLocaleDateString('en-CA')} 18:00`,
    }
  },
  methods: {
    store() {
      this.form.post(route('admin.elections.store'))
    },
  },
}
</script>
